import { Modal } from "antd";
import React, { useState, useEffect } from "react";

function ImageShow({ props }) {
  const { isVisible, onClose, dataImage } = props;
  const [isImage, setImage] = useState("");
  const [isIndex, setIndex] = useState(0);

  useEffect(() => {
    if (isVisible && dataImage) {
      if (typeof dataImage !== "string") {
        setImage(dataImage[0]);
      } else {
        setImage(dataImage);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible]);

  return (
    <Modal
      title={null}
      visible={isVisible}
      onOk={null}
      onCancel={null}
      footer={null}
      closable={false}
      keyboard={false}
      width={typeof dataImage !== "string" ? 800 : 400}
    >
      <div className="relative">
        <div
          className={`grid grid-cols-1 grid-rows-1 ${
            typeof dataImage !== "string" ? "lg:grid-cols-3" : ""
          } gap-5 lg:gap-2`}
        >
          <div
            className={`${
              typeof dataImage !== "string" ? "lg:col-span-2" : ""
            } flex justify-center`}
          >
            <img
              className="w-72 h-60 lg:w-96 lg:h-96 object-cover rounded-2xl cursor-pointer"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/assets/image/img_empty.png"; // some replacement image
              }}
              src={process.env.REACT_APP_BACKEND_URL + "/storage/" + isImage}
              alt="img-media"
            />
          </div>

          {typeof dataImage !== "string" && (
            <div>
              <p className="header-content text-lg colors-blue mb-2 font-semibold">
                Gambar Product
              </p>

              <div className="grid grid-rows-1 grid-cols-3 gap-2">
                {typeof dataImage !== "string" &&
                  dataImage.map((it, index) => (
                    <div
                      key={index}
                      className={
                        index === isIndex
                          ? "rounded-2xl cursor-pointer border-2 border-blue-300"
                          : ""
                      }
                    >
                      <img
                        onClick={() => {
                          setImage(it);
                          setIndex(index);
                        }}
                        key={index}
                        className="w-24 h-20 object-cover rounded-2xl cursor-pointer border-2 border-blue-400"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "/assets/image/img_empty.png"; // some replacement image
                        }}
                        src={
                          process.env.REACT_APP_BACKEND_URL + "/storage/" + it
                        }
                        alt="img-media"
                      />
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
        <div className="absolute  w-auto cursor-pointer -top-3 -right-3 z-30 ">
          <img
            onClick={onClose}
            src={process.env.REACT_APP_BASE_URL + "/assets/icon/ic_close.svg"}
            alt="icon-close"
            className="h-7"
          />
        </div>
      </div>
    </Modal>
  );
}

export default ImageShow;
